<template>
  <div class="insurances-list">
    <v-mockup v-if="isLoading" tag="ul" :counter="8" widget="insurance" />
    <ul v-else>
      <li v-for="(insurance, index) in currList" :key="index" @click="showInsurance(index)">
        <img :src="insurance.img" :alt="insurance.title">
      </li>
    </ul>
    <v-btn model="color-e"
      v-if="currList.length < 13 && !isLoading"
      @click="loadMore()"
      :outline="true">
        Carregar mais convênios
    </v-btn>
    <v-lightbox :active="Object.keys(currInsurance).length > 0" @close="currInsurance = {}">
      <img :src="currInsurance.img" :alt="currInsurance.title">
      <v-heading level="h6">Categorias atendidas no URC:</v-heading>
      <body-text>
        <ul>
          <li v-for="(plan, index) in currInsurancePlans" :key="index">
            {{plan.title}}
          </li>
        </ul>
      </body-text>
      <v-btn tag="router-link"
        :to="`/pre-agendamento?convenio=${currInsurance.id}`"
        model="color-e">
          Faça agora um pré-agendamento
      </v-btn>
    </v-lightbox>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Heading from '@/components/uikit/text/Heading.vue';
import Mockup from '@/components/uikit/mockup/Mockup.vue';
import Lightbox from '@/components/layout/Lightbox.vue';
import BodyText from '@/components/uikit/text/BodyText.vue';
import Btn from '@/components/uikit/Btn.vue';

export default {
  name: 'InsurancesList',
  components: {
    'v-heading': Heading,
    'v-mockup': Mockup,
    'v-lightbox': Lightbox,
    'body-text': BodyText,
    'v-btn': Btn,
  },
  computed: {
    ...mapState({
      insurances: state => state.insurances.list.items,
      currInsurancePlans: state => state.insurances.plans.items,
    }),
    ...mapGetters({
      isLoading: 'insurances/list/isLoading',
    }),
  },
  data() {
    return {
      currList: () => [],
      currInsurance: () => {},
    };
  },
  methods: {
    loadMore() {
      this.currList = this.insurances;
    },
    async showInsurance(insurance) {
      await this.$store.dispatch('insurances/plans/getItems', this.currList[insurance].id);
      this.currInsurance = this.currList[insurance];
    },
  },
  async created() {
    await this.$store.dispatch('insurances/list/getItems');
    this.currList = this.insurances.slice(0, 12);
  },
};
</script>

<style lang="scss" scoped>
$component: '.insurances-list';
#{$component} {
  text-align: center;
  > ul {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: $gutter-l;
    margin-bottom: $gutter-xl;
    @media screen and (max-width: #{$brakepoint-medium}) {
      grid-template-columns: repeat(2, 1fr);
    }
    li {
      display: flex;
      align-items: center;
      justify-content: center;
      width: auto;
      height: 144px;
      background-color: $color-sys-k;
      border-radius: $border-radius;
      cursor: pointer;
      transition: transform $transition-duration $transition-timing-function,
        box-shadow $transition-duration $transition-timing-function;
      &:hover {
        transform: translateY(#{-($gutter/2)});
        box-shadow: $box-shadow-l;
      }
      &:active {
        transform: translateY(#{-($gutter/4)});
        box-shadow: $box-shadow;
      }
      img {
        filter: invert(100%);
        opacity: 0.7;
        max-width: 70%;
      }
    }
  }
  .btn {
    margin-bottom: $gutter-xxxl;
  }
  .lightbox {
    text-align: center;
    /deep/ img {
      margin-bottom: $gutter-xxl;
      filter: invert(100%);
      opacity: 0.7;
    }
    /deep/ ul,
    /deep/ .heading {
      text-align: left;
    }
  }
}
</style>
